var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusDeliveredSome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9427 8.45455L0.911458 13.3333V10.4167L12.9427 8.45455ZM0 0V5.83333L12.5 7.5L0 9.16667V15L17.5 7.5L0 0Z",
    fill: "#DDA021"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusDeliveredSome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_status_delivered_some.319ddacc63ffaaebd6ed820240608029.svg";